import { _ as _sfc_main } from "./VaAspectRatio.vue_vue_type_script_lang-54f0fcc9.mjs";
import { openBlock, createElementBlock, normalizeStyle, createCommentVNode, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaAspectRatio_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "va-aspect-ratio",
    style: normalizeStyle(`--va-0-max-width-computed: ${String(_ctx.maxWidthComputed)}`)
  }, [
    _ctx.stylesComputed ? (openBlock(), createElementBlock("div", {
      key: 0,
      style: normalizeStyle(_ctx.stylesComputed)
    }, null, 4)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ], 4);
}
const _VaAspectRatio = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaAspectRatio as _
};

import '../../../VaAspectRatio.css';
//# sourceMappingURL=VaAspectRatio-34d4a721.mjs.map
